import { render, staticRenderFns } from "./headersView.vue?vue&type=template&id=191a16fa&scoped=true"
import script from "./headersView.vue?vue&type=script&lang=js"
export * from "./headersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a16fa",
  null
  
)

export default component.exports